import styled, { css } from 'styled-components';
import { mq, getSpace, getTextType } from '../../../stylesheets/tools';

const StyledForm = styled.form`
  .form__inner {
    margin: 0 auto;

    ${mq('m')} {
      display: flex;
      flex-wrap: wrap;
    }

    select {
      color: inherit;
    }
  }

  .form__cell {
    width: 100%;
    margin-bottom: ${getSpace('m')};

    ${mq('m')} {
      flex-grow: 1;
      padding: 0 10px;
      margin-bottom: ${getSpace('l')};

      &--half {
        flex-grow: 0;
        width: 50%;
      }

      &--quarter {
        flex-grow: 0;
        width: 25%;
      }

      &--three-quarters {
        flex-grow: 0;
        width: 75%;
      }
    }
  }

  .form__submit-button {
    display: flex;
    justify-content: flex-end;

    button {
      ${mq('m')} {
        margin: 0;
      }
    }
  }

  .form__recaptcha-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .form__recaptcha-error {
    position: absolute;
    text-transform: uppercase;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: red;
    padding: 10px 15px;
    visibility: hidden;
    opacity: 0;
  }

  .form__recaptcha {
    min-height: 78px;
    position: relative;
    border: 2px solid transparent;
    border-radius: 5px;

    &.has-error {
      border-color: red;

      .form__recaptcha-error {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  .checkbox__labelText {
    margin-top: 5px;
  }
  .checkbox__wrapper {
    padding: 0 10px;
    margin-bottom: ${getSpace('m')};
    margin-right: ${getSpace('m')};
  }

  .checkbox__custom-checkbox {
    height: 30px;
    width: 30px;

    svg {
      width: 30px;
    }
  }

  .infoText {
    ${getTextType('copy', 'international')};

    margin: 0;
    h3,
    h2,
    h1,
    p {
      margin-left: 0;
      margin-top: 0;
    }
  }

  .input__label {
    ${props =>
      props.labelWidth &&
      css`
        width: ${props => props.labelWidth}px;
      `}
  }
`;

export default StyledForm;
